import initialState from '../initialState.js';
import { v4 } from 'uuid';
import analyticsService from '../../services/analytics.service';
import { Events } from '../../utils/analytics.js';

const state = {
  analyticsData: { ...initialState.analytics },
  apiKey: process.env.VUE_APP_API_KEY,
  analyticsURL: process.env.VUE_APP_ANALYTICS_API,
  utmData: {},
}
const getters = {
  getAnalyticalData(state) {
    return state.analyticsData;
  },
  getApiUrl(state) {
    return state.apiUrl;
  },
  getUserOrigin(state) {
    return state.analyticsData.origin;
  },
  getUtmData() {
    return state.utmData;
  }
}
const mutations = {
  setUserOrigin(state, data) {
    state.analyticsData = Object.assign(state.analyticsData, {
      origin: data
    });
  },
  setAnalyticsData(state, data) {
    state.analyticsData = data;
  },
  setSubscription(state, data) {
    state.analyticsData = Object.assign(state.analyticsData, {
      subscription: data
    });
  },
  setPayment(state, data) {
    state.analyticsData = Object.assign(state.analyticsData, { payment: data });
  },
  setUserInfo(state, data) {
    state.analyticsData = Object.assign(state.analyticsData, data);
  },
  setUtmData(state, payload) {
    state.utmData = payload;
  }
}
const actions = {
  updateUserOrigin({ commit }, data) {
    commit('setUserOrigin', data);
  },
  updatePaymentsPayload({ commit }, data) {
    commit('setPayment', data);
  },
  updateUserPayload({ commit }, data) {
    commit('setUserInfo', data);
  },
  updateSubscriptionPayload({ commit }, data) {
    commit('setSubscription', data);
  },
  resetUtmData({ commit }, data) {
    commit("setUtmData", {});
  },
  updateUtmData({ commit }, data) {
    if (
      data.utm_source ||
      data.utm_medium ||
      data.utm_campaign ||
      data.utm_content ||
      data.utm_term
    ) {
      commit("setUtmData", {
        utmSource: data.utm_source || '',
        utmMedium: data.utm_medium || '',
        utmCampaign: data.utm_campaign || '',
        utmContent: data.utm_content || null,
        utmTerm: data.utm_term || null,
      });
    }
  },
  postAnalytics({ commit, state }, event) {
    // check if anything in utm data send inside analytics
    const data = {
      ...state.analyticsData,
      transactionUuid: v4(),
      event
    };
    if (event === Events.CLICKREGISTER && state.utmData && Object.keys(state.utmData).length > 0) {
      data.utm = state.utmData;
    }
    return analyticsService
      .postAnalytics(
        null,
        data,
        state.apiKey,
        state.analyticsURL
      )
      .then((res) => {
        if (event === Events.CLICKREGISTER) {
          // commit("setUtmData", {});
        }
      })
      .catch((err) => {
        console.error(err);
      });
  },
}

export default {
  state,
  getters,
  actions,
  mutations
}